import { render } from "./etStatusEdit.vue?vue&type=template&id=054a130c"
import script from "./etStatusEdit.vue?vue&type=script&lang=js"
export * from "./etStatusEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__